import { columns } from "../../../../dtos/columns";
import { MovimientoContable } from "../models/consultaMovimientoContable";



export function useColumns() {

    const COLUMNS: columns<MovimientoContable>[] = [
        {
            name: 'Acción',
            selector: (row) =>
                row.descripcionAccion,
            sortable: true,
            sortField: 'descripcionAccion',
            wrap: true,
            export: true
        },
        {
            name: 'N° Cuenta',
            selector: (row) =>
                row.numeroCuenta,
            sortable: true,
            sortField: 'numeroCuenta',
            wrap: true,
            export: true
        },
        {
            name: 'Descripción Cuenta',
            selector: (row) =>
                row.descripcionCuenta,
            sortable: true,
            sortField: 'descripcionCuenta',
            wrap: true,
            export: true
        },
        {
            name: 'Debe',
            selector: (row) =>
                row.montoDebe,
            sortable: true,
            sortField: 'montoDebe',
            wrap: true,
            export: true
        },
        {
            name: 'Haber',
            selector: (row) =>
                row.montoHaber,
            sortable: true,
            sortField: 'montoHaber',
            wrap: true,
            export: true
        },

    ]
    return { COLUMNS };
}
